import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDownUpIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M5.5 12.25 8 9.75l2.5 2.5M10.5 3.75 8 6.25l-2.5-2.5" })
});
export default SvgChevronDownUpIcon;
